export function extractUserName(email) {
  const parts = email.split('@');
  const username = parts[0];
  const cleanUsername = username.replace(/[^a-zA-Z]/g, '');
  return cleanUsername;
}
